import {Button, Card, CardBody, CardHeader, Typography,} from "@material-tailwind/react";
import React, {useEffect, useState} from "react";
import {BranchServiceStepGrid} from "./grid";
import {BranchServiceStepForm} from "./form";
import {getBranchServiceSteps} from "../../services/branch_service_step/branch_service_step";
import {BranchServiceStepContext} from "../../context/branch_service_step_context";
import {PaginateContext} from "../../context/paginate";
import {CardFooterPaginator} from "../system/cardFooterPaginator";
import Dict from "../../helper/dict";
import {getFieldBranches} from "../../services/branch/branch";
import SelectInput from "../system/select";


export function BranchServiceStepManagement() {

  const [BranchServiceSteps, setBranchServiceSteps] = useState([]);
  const [modalOpen, setModalOpen] = useState(false);
  const [gridRowCount, setGridRowCount] = useState(10);
  const [gridCurrentPage, setGridCurrentPage] = useState(1);
  const [gridSelectedRow, setGridSelectedRow] = useState(null);
  const [gridTotalRowCount, setGridTotalRowCount] = useState(0);
  const [sortBy, setSortBy] = useState("id")
  const [sortType, setSortType] = useState(false);
  const [from, setFrom] = useState((gridCurrentPage - 1) * gridRowCount + 1);
  const [to, setTo] = useState((gridCurrentPage) * gridRowCount);
  const [lastDataRefresh, setLastDataRefresh] = useState(null);

  const [branchId, setBranchId] = useState(null)

  useEffect(() => {
    if ((gridCurrentPage) * gridRowCount <= gridTotalRowCount) {
      setTo((gridCurrentPage) * gridRowCount)
    } else {
      setTo(gridTotalRowCount)
    }
    if (gridTotalRowCount === 0) {
      setFrom(0)
    } else {
      setFrom((gridCurrentPage - 1) * gridRowCount + 1)
    }
  }, [gridCurrentPage, gridRowCount, gridTotalRowCount]);

  async function getData(paginate) {
    const result = await getBranchServiceSteps(paginate);
    if (result.status === 200) {
      const {branchServiceStepList, total_count} = result.data;
      setBranchServiceSteps(branchServiceStepList || []);
      setGridTotalRowCount(total_count);
    }
  }

  const filter = () => {
    const filterParams = {}

    if (branchId) {
      filterParams["branch_id"] = branchId
    }

    return filterParams;
  }

  useEffect(() => {
    // const data = filter()
    const paginateParams = new URLSearchParams({
      "sort_by": sortBy,
      "sort_type": sortType === false ? "DESC" : "ASC",
      "limit": parseInt(gridRowCount),
      "offset": (parseInt(gridCurrentPage) - 1) * parseInt(gridRowCount),
    })

    const params = filter();
    const filterParams = new URLSearchParams(params);

    for (const [key, value] of filterParams.entries()) {
      paginateParams.append(key, value);
    }

    const paginate = paginateParams.toString()

    getData(paginate)
  }, [branchId, gridCurrentPage, gridRowCount, sortBy, sortType, lastDataRefresh]);

  return (
    <BranchServiceStepContext.Provider value={{
      modalOpen,
      setModalOpen,
      gridRowCount,
      setGridRowCount,
      gridCurrentPage,
      setGridCurrentPage,
      branchServiceStep: gridSelectedRow,
      setBranchServiceStep: setGridSelectedRow,
      lastDataRefresh,
      setLastDataRefresh,
    }}>
      <PaginateContext.Provider value={{
        setSortBy: setSortBy,
        sortType: sortType,
        setSortType: setSortType,
        active: gridCurrentPage,
        setActive: setGridCurrentPage,
        totalRows: gridTotalRowCount,
        rowsCount: gridRowCount,
        setRowsCount: setGridRowCount,
        from: from,
        to: to,
      }}>
        <div className="">
          <BranchServiceStepForm/>
          <Card className="pt-8">
            <CardHeader floated={true} shadow={false} className="rounded-none">
              <div className="mb-8 flex items-center justify-between gap-8">
                <Typography variant="h5" color="blue-gray">مراحل انجام خدمت</Typography>
                <Button onClick={() => {
                  setGridSelectedRow(null);
                  setModalOpen(true);
                }} variant="outlined">جدید</Button>
              </div>
            </CardHeader>
            <CardBody className="overflow-x-auto w-full">

              <div className="grid grid-cols-1 gap-2 mb-2 md:grid-cols-2 xxl:grid-cols-3">

                <div className="flex flex-col">
                  <SelectInput
                    label={Dict("raw_branch")}
                    defaultValue={branchId}
                    autoLoadService={getFieldBranches}
                    autoLoadRender={({field_title, title}) => {
                      return field_title + " - " + title
                    }}
                    onChange={setBranchId}
                  />

                </div>

                <div className="flex flex-col max-w-fit">
                  <Button variant="gradient" color="gray" onClick={() => {
                    setBranchId(null)
                  }} className="ml-1">
                    <span>حذف فیلتر</span>
                  </Button>

                </div>

              </div>
              <BranchServiceStepGrid
                BranchServiceSteps={BranchServiceSteps}
              />
            </CardBody>

            <CardFooterPaginator/>

          </Card>
        </div>
      </PaginateContext.Provider>
    </BranchServiceStepContext.Provider>
  );
}